import { CornerDownRight } from 'lucide-react';
import { ProfileNav } from '../../../../components/profile/ProfileNav';

/** One leave type on the rail, in the Credit Balance table's parent-then-children order. */
export interface LeaveLedgerRailType {
  id: string;
  name: string;
  /** Drawn under its parent with the balance table's own glyph. */
  isChild: boolean;
  count: number;
}

/** `'all'`, or a leave type's id. */
export type LeaveLedgerTypeFilter = string;

/**
 * The Leave Ledger's FILTER RAIL (product call, 27 Oct 2026) — All, then every leave type with
 * its entry count, the shared `<ProfileNav>` in a `w-56` aside at the panel's left edge: the
 * shape `<ApplicantFilterRail>` set for a rail inside a panel.
 *
 * A type is listed at ZERO too — it is a catalog, and an empty count is the answer to "has any
 * been recorded". A child sits under its parent with the Credit Balance table's glyph, and
 * picking it lists that type's own rows only.
 */
export function LeaveLedgerTypeRail({
  id,
  active,
  total,
  types,
  onSelect,
}: {
  id: string;
  active: LeaveLedgerTypeFilter;
  /** Every entry on the ledger — undefined until the first load. */
  total: number | undefined;
  types: LeaveLedgerRailType[];
  onSelect: (key: LeaveLedgerTypeFilter) => void;
}) {
  return (
    <aside
      aria-label="Filter the ledger by leave type"
      className="modern-scrollbar w-56 shrink-0 overflow-y-auto overflow-x-hidden border-r border-slate-200 bg-white"
    >
      <ProfileNav
        id={id}
        entries={[
          { key: 'all', label: 'All', count: total },
          ...types.map((t) => ({
            key: t.id,
            label: t.name,
            count: t.count,
            icon: t.isChild ? (
              <CornerDownRight className="h-3.5 w-3.5 text-slate-300" aria-hidden="true" />
            ) : undefined,
          })),
        ]}
        activeKey={active}
        onSelect={onSelect}
      />
    </aside>
  );
}
